module.exports = __webpack_public_path__ + "static/media/chef.b4d363d2.svg";